/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { xScreen } from "@rc/XDL/Utilities";
import React from "react";
import { css } from "styled-components";

const enum fields {}

interface AnonymousWelcomeContentProps extends WidgetProps {
    fields: {};
}

export interface AnonymousWelcomeContentStyles {
    container?: InjectableCss;
    left?: InjectableCss;
    right?: InjectableCss;
}

export const anonymousWelcomeContentStyles: AnonymousWelcomeContentStyles = {
    container: {
        css: css`
            display: flex;
            ${xScreen("lte", "md")} {
                flex-direction: column-reverse;
            }
        `,
    },
    right: {
        css: css`
            width: 418px;

            ${xScreen("lte", "md")} {
                width: 100%;
            }
        `,
    },
    left: {
        css: css`
            width: calc(100% - 418px);
            padding-right: 22px;

            ${xScreen("lte", "md")} {
                width: 100%;
                padding-right: 0;
                margin-top: 32px;
            }
        `,
    },
};

const styles = anonymousWelcomeContentStyles;

const AnonymousWelcomeContent: React.FC<AnonymousWelcomeContentProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.left}>
                <Zone contentId={id} zoneName="Content1" />
            </StyledWrapper>
            <StyledWrapper {...styles.right}>
                <Zone contentId={id} zoneName="Content2" />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export const definition: WidgetDefinition = {
    group: "XNGAGE" as any,
    fieldDefinitions: [],
};

const widgetModule: WidgetModule = {
    component: AnonymousWelcomeContent,
    definition,
};

export default widgetModule;
